import React from "react";
import { Sparkles } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";

export function AILabel({ className = "" }) {
  const { t } = useI18n();
  return (
    <span
      data-testid="ai-review-label"
      className={
        "inline-flex items-center gap-1 rounded-md border border-violet-200 bg-violet-50 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider text-violet-700 dark:border-violet-800 dark:bg-violet-950/40 dark:text-violet-300 " +
        className
      }
    >
      <Sparkles className="h-3 w-3" strokeWidth={2} />
      {t("common.review")}
    </span>
  );
}

export default AILabel;
